import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Container = styled.div`
	display: flex;
`;

const InputGroup = styled.label`
	font-size: 14px;
	margin-right: 8px;

	&:nth-last-child(1) {
		margin-right: 0;
	}
`;

const Input = styled.input`
	background-color: rgb(240,240,240);
	border: 2px solid rgb(240,240,240);
	border-radius: 4px;
	width: 100%;
	height: 24px;
	margin-top: 4px;
	padding: 2px 8px;
	font-size: 14px;
	transition: all 0.3s ease-out;

	&:hover {
		background-color: rgb(230,230,230);
	}

	&:focus {
		border-color: #6990D9;
		background-color: white;
		outline: none;
	}
`;

class RangeGroup extends React.Component {
	state = {
	  min: this.props.range.min,
	  max: this.props.range.max,
	}

	componentWillReceiveProps(nextProps) {
	  if (this.props.range.min !== nextProps.range.min || this.props.range.max !== nextProps.range.max) {
	    this.setState({
	      min: nextProps.range.min,
	      max: nextProps.range.max,
	    });
	  }
	}

	minChangeHandler = e => {
	  this.setState({ min: parseInt(e.target.value, 10) || this.props.range.min });
	}

	maxChangeHandler = e => {
	  this.setState({ max: parseInt(e.target.value, 10) || this.props.range.max });
	}

	blurHandler = key => {
	  if (this.state[key] !== this.props.range[key]) {
	    this.props.rangeHandler(key, this.state[key]);
	  }
	}

	render() {
	  return (
	    <Container>
	      <InputGroup>
					Min
	        <Input
	          value={this.state.min}
	          onChange={this.minChangeHandler}
	          onBlur={() => this.blurHandler('min')}
	        />
	      </InputGroup>
	      <InputGroup>
					Max
	        <Input
	          value={this.state.max}
	          onChange={this.maxChangeHandler}
	          onBlur={() => this.blurHandler('max')}
	        />
	      </InputGroup>
	    </Container>
	  )
	}
}

RangeGroup.propTypes = {
	range: PropTypes.shape({
		min: PropTypes.number,
		max: PropTypes.number,
		minSelected: PropTypes.bool,
		maxSelected: PropTypes.bool,
	}),
	checkHandler: PropTypes.func,
	rangeHandler: PropTypes.func,
	selectHandler: PropTypes.func,
}

export default RangeGroup
